import { Flex, Text } from '@mantine/core';
import { useTranslations } from 'next-intl';

import { Arrow } from '../../atoms/Arrow/Arrow';
import css from './TrialDecoration.module.css';

export const TrialDecoration = () => {
  const t = useTranslations('section.hero.cta');

  return (
    <Flex
      className={`${css.container} desktop`}
      direction="column"
      align="center"
    >
      <Arrow />
      <Text className={`${css.text}`}>{t('text')}</Text>
    </Flex>
  );
};
